import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../services/api'

import styles from './styles.module.scss'

type ArticlesProps = {
    id: string;
}

type ListaDeArtigos = {
    ID: number;
    CM_CAT_UNIVERSAL: number;
    CM_CAT_ID: string;
    CM_TITULO: string;
    CM_DESCRICAO: string;
    CM_CONTEUDO: string;
    CM_VISUALIZADA: null;
    CM_UTIL: null;
    CM_NAO_UTIL: null;
}

export function ArtigosByCategory() {

    const [articleList, setArticleList] = useState<ListaDeArtigos[]>([])

    const { id } = useParams<ArticlesProps>()

    useEffect(() => {
        async function fetchData() {
            const result = await api.get(`/manuais/artigos/categoria/${id}`)

            setArticleList(result.data.filter((article: any) => article.CM_NOME ? false : true))
        }

        fetchData()
    }, [id])

    function openArticle(articleId: number) {
        window.location.pathname = `${process.env.REACT_APP_BASE_URL}/artigo/${articleId}`
    }

    let content

    if (!articleList.length) {
        content = (
            <div className={styles.withoutArticleContainer}>
                <h2>Essa categoria não possui nenhum artigo correspondente.</h2>
                <h2>Tente selecionar outra categoria relacionada ou acesse a aba "Ajuda" para entrar em contato com o departamento correspondente.</h2>
            </div>
        )
    } else {
        content = (
            articleList.map((artigo, key) => (
                <div key={key} className={styles.liContainer} onClick={() => openArticle(artigo.ID)}>
                    <li className={styles.articleTitle}>{artigo.CM_TITULO}</li>
                    <div className={styles.legendsContainer}>
                        {/*<li className={styles.articleDescription}>{artigo.CM_DESCRICAO}</li>*/}
                        {/* <li className="articleAutor">Autor: {artigo.CM_AUTOR}</li> */}
                    </div>
                </div>
            )))
    }
    return (
        <>
            {
                content
            }
        </>
    )
}